module.exports = __webpack_public_path__ + "static/index/img/edit.f1f7eea5.png";